export const initialSettingsData = {
  birthdate: '1970-01-01',
  country: {},
  email: '',
  name: '',
  profile_photo_path: '',
  city: {},
  username: '',
  gender: 'custom',
  is_remove_avatar: 0,
};
